export * from "./sticker-forge";

import { defineStickerForge } from "./sticker-forge";

defineStickerForge();
